import { PermissionId } from '@e2m-customer-portal/shared';
import { ErrorComponent, Loading, PageTitle, Toolbar } from '@e2m-customer-portal/ui';
import { Button } from '@mui/material';
import { ReactElement, Suspense, useState } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { DialogAccount, UserDialog } from './UserDialog';
import { UserList } from './UserList';

function createEmptyAccount(): DialogAccount {
  return {
    __typename: 'Account',
    id: '',
    email: '',
    name: '',
    permissions: Object.values(PermissionId).map((permissionId) => ({
      permissionId,
      granted: false,
    })),
    marketLocations: [],
  };
}

export function UserManagement(): ReactElement {
  const [t] = useTranslation();
  const [open, setOpen] = useState(false);
  const [account, setAccount] = useState<DialogAccount>(createEmptyAccount());

  return (
    <>
      <PageTitle title={t('SETTINGS_USER_MANAGEMENT_TITLE')} />
      <Toolbar
        right={
          <Button
            onClick={() => {
              setAccount(createEmptyAccount());
              setOpen(true);
            }}
          >
            {t('SETTINGS_USER_MANAGEMENT_NEW_USER_TITLE')}
          </Button>
        }
      />

      <div className="bg-grey-50 h-full py-6 sm:px-8">
        <ErrorBoundary FallbackComponent={ErrorComponent}>
          <Suspense fallback={<Loading />}>
            <UserList
              onStartEditing={(acc) => {
                setAccount(acc);
                setOpen(true);
              }}
            />
          </Suspense>
        </ErrorBoundary>
      </div>

      <ErrorBoundary FallbackComponent={ErrorComponent}>
        <UserDialog
          variant={account.id ? 'edit' : 'create'}
          open={open}
          onClose={() => {
            setOpen(false);
          }}
          account={account}
          onChange={setAccount}
        />
      </ErrorBoundary>
    </>
  );
}
